var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SectionHeader", {
    attrs: {
      "show-content": _vm.defaultBidSettingsShowContents,
      "widget-title": _vm.$t("HEADER_DEFAULT_BID_SETTINGS")
    },
    on: {
      onShowContentsClick: function($event) {
        return _vm.onDefaultBidSettingsShowContentsClick()
      }
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function() {
          return [
            _c(
              "form",
              {
                staticClass: "form-horizontal",
                attrs: { role: "form", name: "vm.campaignForm" }
              },
              [
                _vm.overridesAvailable
                  ? _c(
                      "div",
                      [
                        _c("Field", {
                          attrs: {
                            label: _vm.$t(
                              "LABEL_OVERRIDE_DEFAULT_BID_SETTINGS"
                            ),
                            "hide-label": false,
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t(
                              "TOOLTIP_OVERRIDE_DEFAULT_BID_SETTINGS"
                            )
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "p-l-0 col-sm-5 col-md-1"
                                      },
                                      [
                                        _c(
                                          "ValidationProvider",
                                          {
                                            attrs: {
                                              rules: "required",
                                              slim: ""
                                            }
                                          },
                                          [
                                            _c("nzToggle", {
                                              attrs: {
                                                "data-cy":
                                                  "default-bid-settings-overide-toggle"
                                              },
                                              on: {
                                                onToggle:
                                                  _vm.overrideDefaultBidSettingsToggle
                                              },
                                              model: {
                                                value:
                                                  _vm.overrideDefaultBidSettings,
                                                callback: function($$v) {
                                                  _vm.overrideDefaultBidSettings = $$v
                                                },
                                                expression:
                                                  "overrideDefaultBidSettings"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            341375733
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.overridesAvailable || _vm.overrideDefaultBidSettings
                  ? _c(
                      "div",
                      [
                        _c("Field", {
                          attrs: {
                            label: _vm.$t("LABEL_BASE_BID_AMOUNT"),
                            "hide-label": false,
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t("TOOLTIP_BASE_BID_AMOUNT")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        rules: _vm.passThroughBidEnabled
                                          ? ""
                                          : "required|min_value:0",
                                        slim: ""
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ classes, errors }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "p-l-0 col-sm-5 col-md-1",
                                                    class: {
                                                      "display-none":
                                                        _vm.passThroughBidEnabled
                                                    }
                                                  },
                                                  [
                                                    _c("input", {
                                                      staticClass:
                                                        "form-control dynamic-inbound-calls-basebid-and-maxBidAmount-input",
                                                      class: classes,
                                                      attrs: {
                                                        name:
                                                          "currentBaseBidAmount",
                                                        "data-cy":
                                                          "currentBaseBidAmount",
                                                        required: _vm.passThroughBidEnabled
                                                          ? false
                                                          : true,
                                                        placeholder: _vm.$t(
                                                          "LABEL_PLACEHOLDER_BASE_BID_AMOUNT"
                                                        ),
                                                        type: _vm.baseBidNumericInput
                                                          ? "number"
                                                          : "text",
                                                        disabled:
                                                          _vm.passThroughBidEnabled
                                                      },
                                                      domProps: {
                                                        value: _vm.baseBidAmount
                                                      },
                                                      on: {
                                                        blur: function($event) {
                                                          _vm.currentBaseBidAmount = _vm.currentBaseBidAmount
                                                            ? "$" +
                                                              _vm.currentBaseBidAmount
                                                            : ""
                                                          _vm.baseBidNumericInput = false
                                                        },
                                                        focus: function(
                                                          $event
                                                        ) {
                                                          _vm.currentBaseBidAmount = _vm.currentBaseBidAmount.replace(
                                                            "$",
                                                            ""
                                                          )
                                                          _vm.baseBidNumericInput = true
                                                        },
                                                        input:
                                                          _vm.onBaseBidAmountOnInput,
                                                        change:
                                                          _vm.onBaseBidAmountOnChange
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                errors[0] &&
                                                _vm.passThroughBidEnabledAllowErrors
                                                  ? _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "form-group__label-required vv-invalid",
                                                        attrs: {
                                                          name:
                                                            "currentBaseBidAmount-invalid-label",
                                                          "data-cy":
                                                            "currentBaseBidAmount-invalid-label"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "ERROR_BASE_BID_AMOUNT"
                                                            )
                                                          ) + "\n              "
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "form-group__label-required"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("REQUIRED")
                                                          ) + "\n              "
                                                        )
                                                      ]
                                                    ),
                                                _vm._v(" "),
                                                _vm.passThroughBidEnabled
                                                  ? _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "p-t-7 text-muted",
                                                        attrs: {
                                                          name:
                                                            "currentBaseBidAmount-disabled-label",
                                                          "data-cy":
                                                            "currentBaseBidAmount-disabled-label"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "LABEL_BID_SETTINGS_OVERRIDE"
                                                            )
                                                          ) + "\n              "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        2843572937
                                      )
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            1707724384
                          )
                        }),
                        _vm._v(" "),
                        _c("Field", {
                          attrs: {
                            label: _vm.$t("LABEL_MAX_BID"),
                            "hide-label": false,
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t("TOOLTIP_MAX_BID")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        rules: _vm.passThroughBidEnabled
                                          ? ""
                                          : "required|min_value:0.01",
                                        slim: ""
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ classes, errors }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "p-l-0 col-sm-5 col-md-1",
                                                    class: {
                                                      "display-none":
                                                        _vm.passThroughBidEnabled
                                                    }
                                                  },
                                                  [
                                                    _c("input", {
                                                      staticClass:
                                                        "form-control dynamic-inbound-calls-basebid-and-maxBidAmount-input",
                                                      class: classes,
                                                      attrs: {
                                                        name:
                                                          "currentmaxBidAmount",
                                                        "data-cy":
                                                          "currentmaxBidAmount",
                                                        required: _vm.passThroughBidEnabled
                                                          ? false
                                                          : true,
                                                        placeholder: _vm.$t(
                                                          "LABEL_PLACEHOLDER_MAX_BID"
                                                        ),
                                                        type: _vm.maxBidAmountNumericInput
                                                          ? "number"
                                                          : "text",
                                                        disabled:
                                                          _vm.passThroughBidEnabled
                                                      },
                                                      domProps: {
                                                        value: _vm.maxBidAmount
                                                      },
                                                      on: {
                                                        blur: function($event) {
                                                          _vm.currentmaxBidAmount = _vm.currentmaxBidAmount
                                                            ? "$" +
                                                              _vm.currentmaxBidAmount
                                                            : ""
                                                          _vm.maxBidAmountNumericInput = false
                                                        },
                                                        focus: function(
                                                          $event
                                                        ) {
                                                          _vm.currentmaxBidAmount = _vm.currentmaxBidAmount.replace(
                                                            "$",
                                                            ""
                                                          )
                                                          _vm.maxBidAmountNumericInput = true
                                                        },
                                                        input:
                                                          _vm.onmaxBidAmountOnInput,
                                                        change:
                                                          _vm.onmaxBidAmountOnChange
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                errors[0] &&
                                                _vm.passThroughBidEnabledAllowErrors
                                                  ? _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "form-group__label-required vv-invalid",
                                                        attrs: {
                                                          name:
                                                            "currentmaxBidAmount-invalid-label",
                                                          "data-cy":
                                                            "currentmaxBidAmount-invalid-label"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "ERROR_MAX_BID_AMOUNT"
                                                            )
                                                          ) + "\n              "
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "form-group__label-required"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("REQUIRED")
                                                          ) + "\n              "
                                                        )
                                                      ]
                                                    ),
                                                _vm._v(" "),
                                                _vm.passThroughBidEnabled
                                                  ? _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "p-t-7 text-muted",
                                                        attrs: {
                                                          name:
                                                            "currentBaseBidAmount-disabled-label",
                                                          "data-cy":
                                                            "currentBaseBidAmount-disabled-label"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "LABEL_BID_SETTINGS_OVERRIDE"
                                                            )
                                                          ) + "\n              "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        665146358
                                      )
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            3254897288
                          )
                        }),
                        _vm._v(" "),
                        _c("Field", {
                          attrs: {
                            label: _vm.$t("LABEL_MIN_BID"),
                            "hide-label": false,
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t("TOOLTIP_MIN_BID")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        rules: _vm.passThroughBidEnabled
                                          ? ""
                                          : "min_value:0.01",
                                        slim: ""
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ classes, errors }) {
                                              return [
                                                !_vm.passThroughBidEnabled
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "p-l-0 col-sm-5 col-md-1"
                                                      },
                                                      [
                                                        _c("input", {
                                                          staticClass:
                                                            "form-control dynamic-inbound-calls-basebid-and-minBidAmount-input",
                                                          class: classes,
                                                          attrs: {
                                                            name:
                                                              "currentminBidAmount",
                                                            placeholder: _vm.$t(
                                                              "LABEL_PLACEHOLDER_MIN_BID"
                                                            ),
                                                            type: _vm.minBidAmountNumericInput
                                                              ? "number"
                                                              : "text",
                                                            disabled:
                                                              _vm.passThroughBidEnabled
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.minBidAmount
                                                          },
                                                          on: {
                                                            blur: function(
                                                              $event
                                                            ) {
                                                              _vm.currentminBidAmount = _vm.currentminBidAmount
                                                                ? "$" +
                                                                  _vm.currentminBidAmount
                                                                : ""
                                                              _vm.minBidAmountNumericInput = false
                                                            },
                                                            focus: function(
                                                              $event
                                                            ) {
                                                              _vm.currentminBidAmount = _vm.currentminBidAmount.replace(
                                                                "$",
                                                                ""
                                                              )
                                                              _vm.minBidAmountNumericInput = true
                                                            },
                                                            input:
                                                              _vm.onminBidAmountOnInput,
                                                            change:
                                                              _vm.onminBidAmountOnChange
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                errors[0] &&
                                                _vm.passThroughBidEnabledAllowErrors
                                                  ? _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "form-group__label-required vv-invalid",
                                                        attrs: {
                                                          name:
                                                            "currentminBidAmount-invalid-label"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "ERROR_MIN_BID_AMOUNT"
                                                            )
                                                          ) + "\n              "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.passThroughBidEnabled
                                                  ? _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "p-t-7 text-muted",
                                                        attrs: {
                                                          name:
                                                            "currentBaseBidAmount-disabled-label",
                                                          "data-cy":
                                                            "currentBaseBidAmount-disabled-label"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "LABEL_BID_SETTINGS_OVERRIDE"
                                                            )
                                                          ) + "\n              "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1776656153
                                      )
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            538753007
                          )
                        }),
                        _vm._v(" "),
                        _c("Field", {
                          attrs: {
                            label: _vm.$t("LABEL_PAYOUT_ON"),
                            "hide-label": false,
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t("TOOLTIP_PAYOUT_ON")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        rules: _vm.passThroughBidEnabled
                                          ? ""
                                          : "required",
                                        slim: ""
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ classes }) {
                                              return [
                                                !_vm.passThroughBidEnabled
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "p-l-0 col-sm-4 col-md-3"
                                                      },
                                                      [
                                                        _c(
                                                          "SearchableDropdown",
                                                          {
                                                            staticClass:
                                                              "rtb-default-selector m-b-10",
                                                            class: classes,
                                                            attrs: {
                                                              name:
                                                                "conversionType",
                                                              "data-cy":
                                                                "conversionType",
                                                              config:
                                                                _vm.conversionTypeDropdownConfig,
                                                              searchable: false,
                                                              clearable: false
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.onPayoutOnDropdownOnChange
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.currentConversionType,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.currentConversionType = $$v
                                                              },
                                                              expression:
                                                                "currentConversionType"
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.passThroughBidEnabled
                                                  ? _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "p-t-7 text-muted",
                                                        attrs: {
                                                          name:
                                                            "conversionType-disabled-label",
                                                          "data-cy":
                                                            "conversionType-disabled-label"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "LABEL_TARGET_ROUTE_OVERRIDE"
                                                            )
                                                          ) + "\n              "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        3666657671
                                      )
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            2057716839
                          )
                        }),
                        _vm._v(" "),
                        !_vm.passThroughBidEnabled &&
                        _vm.conversionType == "Call Length"
                          ? _c(
                              "div",
                              [
                                _c("Field", {
                                  attrs: {
                                    label: _vm.$t("LABEL_START_TIMER_EVENT"),
                                    "hide-label": false,
                                    "has-tooltip": true,
                                    "tooltip-text": _vm.$t(
                                      "TOOLTIP_START_TIMER_EVENT"
                                    )
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "element",
                                        fn: function() {
                                          return [
                                            _c(
                                              "ValidationProvider",
                                              {
                                                attrs: {
                                                  rules: _vm.passThroughBidEnabled
                                                    ? ""
                                                    : "required",
                                                  slim: ""
                                                }
                                              },
                                              [
                                                _c("MultipleToggle", {
                                                  attrs: {
                                                    value: _vm.startTimerEvent,
                                                    options:
                                                      _vm.startTimerEventOptions
                                                  },
                                                  on: {
                                                    onToggle:
                                                      _vm.onStartTimerEventChange
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    1250007745
                                  )
                                }),
                                _vm._v(" "),
                                _c("Field", {
                                  attrs: {
                                    label: _vm.$t("LABEL_LENGTH"),
                                    "hide-label": false,
                                    "has-tooltip": true,
                                    "tooltip-text": _vm.$t("TOOLTIP_LENGTH")
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "element",
                                        fn: function() {
                                          return [
                                            _c("ValidationProvider", {
                                              attrs: {
                                                rules: _vm.passThroughBidEnabled
                                                  ? ""
                                                  : "required|min_value:0|integer",
                                                slim: ""
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({
                                                      classes,
                                                      errors
                                                    }) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "p-l-0 col-sm-5 col-md-1"
                                                          },
                                                          [
                                                            _c("input", {
                                                              staticClass:
                                                                "form-control",
                                                              class: classes,
                                                              attrs: {
                                                                name:
                                                                  "currentCallLengthInSeconds",
                                                                "data-cy":
                                                                  "currentCallLengthInSeconds",
                                                                required: true,
                                                                placeholder: _vm.$t(
                                                                  "LABEL_PLACEHOLDER_LENGTH"
                                                                ),
                                                                type: "number"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm.callLengthInSeconds
                                                              },
                                                              on: {
                                                                input:
                                                                  _vm.onCallLengthInSecondsOnInput,
                                                                change:
                                                                  _vm.onCallLengthInSecondsOnChange,
                                                                wheel: function(
                                                                  $event
                                                                ) {
                                                                  return $event.target.blur()
                                                                }
                                                              }
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "m-t-10"
                                                          },
                                                          [_vm._v("seconds")]
                                                        ),
                                                        _vm._v(" "),
                                                        errors[0]
                                                          ? _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form-group__label-required vv-invalid",
                                                                attrs: {
                                                                  "data-cy":
                                                                    "currentCallLengthInSeconds-error-label"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Length must be a number and greater or equal to zero\n                "
                                                                )
                                                              ]
                                                            )
                                                          : _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form-group__label-required p-l-10"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "REQUIRED"
                                                                    )
                                                                  ) +
                                                                    "\n                "
                                                                )
                                                              ]
                                                            )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                4265746818
                                              )
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    1483068016
                                  )
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("Field", {
                          attrs: {
                            label: _vm.$t("LABEL_DUPLICATE_PAYOUTS"),
                            "hide-label": false,
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t("TOOLTIP_DUPLICATE_PAYOUTS")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "p-l-0 col-sm-6 col-md-6"
                                      },
                                      [
                                        _c(
                                          "ValidationProvider",
                                          {
                                            attrs: {
                                              rules: "required",
                                              slim: ""
                                            }
                                          },
                                          [
                                            _c(
                                              "MultipleToggle",
                                              {
                                                attrs: {
                                                  value:
                                                    _vm.secondsFromLastCallToggleValue,
                                                  options:
                                                    _vm.secondsFromLastCallToggleValueOptions
                                                },
                                                on: {
                                                  onToggle:
                                                    _vm.onSecondsFromLastCallToggleValueChange
                                                }
                                              },
                                              [
                                                [
                                                  _vm.secondsFromLastCallToggleValue >
                                                  0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass: "m-t-5"
                                                        },
                                                        [
                                                          _c(
                                                            "ValidationProvider",
                                                            {
                                                              attrs: {
                                                                rules:
                                                                  "required",
                                                                slim: ""
                                                              }
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model.lazy",
                                                                    value:
                                                                      _vm.daysFromLastCall,
                                                                    expression:
                                                                      "daysFromLastCall",
                                                                    modifiers: {
                                                                      lazy: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "form-control dynamic-inbound-calls-timeout-input",
                                                                attrs: {
                                                                  type:
                                                                    "number",
                                                                  min: "0",
                                                                  oninput:
                                                                    "validity.valid||(value='')"
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.daysFromLastCall
                                                                },
                                                                on: {
                                                                  wheel: function(
                                                                    $event
                                                                  ) {
                                                                    return $event.target.blur()
                                                                  },
                                                                  change: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.daysFromLastCall =
                                                                      $event.target.value
                                                                  }
                                                                }
                                                              })
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "dynamic-inbound-calls-timeout-labels"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.daysFromLastCall >
                                                                    1
                                                                    ? "Days"
                                                                    : "Day"
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "ValidationProvider",
                                                            {
                                                              attrs: {
                                                                rules:
                                                                  "required",
                                                                slim: ""
                                                              }
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model.lazy",
                                                                    value:
                                                                      _vm.hoursFromLastCall,
                                                                    expression:
                                                                      "hoursFromLastCall",
                                                                    modifiers: {
                                                                      lazy: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "form-control dynamic-inbound-calls-timeout-input",
                                                                attrs: {
                                                                  type:
                                                                    "number",
                                                                  min: "0",
                                                                  oninput:
                                                                    "validity.valid||(value='')"
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.hoursFromLastCall
                                                                },
                                                                on: {
                                                                  wheel: function(
                                                                    $event
                                                                  ) {
                                                                    return $event.target.blur()
                                                                  },
                                                                  change: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.hoursFromLastCall =
                                                                      $event.target.value
                                                                  }
                                                                }
                                                              })
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "dynamic-inbound-calls-timeout-labels"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.hoursFromLastCall >
                                                                    1
                                                                    ? "Hours"
                                                                    : "Hour"
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              ],
                                              2
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            1869853391
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }